var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBusTimetable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18,12.4h-6H6V6.5h5.6c0-1.4,0.5-2.7,1.4-3.8h-1h-1.6c-0.3,0-0.7,0.1-1,0.1C8.3,2.9,7.2,3,6.2,3.4 C5.8,3.5,5.6,3.6,5.4,3.8C5,4,4.7,4.4,4.6,4.9C4.4,5.6,4.3,6.5,4.2,7.2c0,0.1-0.1,0.2-0.2,0.2C3.7,7.5,3.4,7.9,3.4,8.3 c0,0.6,0,1.3,0,1.9c0,0.3,0.2,0.6,0.5,0.8C3.9,11,4,11,4,11.1c0,1.9,0,3.8,0,5.6C4,17.3,4,17.9,4,18.5c0,0.5,0.3,0.8,0.7,0.8 c0.2,0,0.4,0,0.6,0c0.1,0,0.1,0,0.2,0c0,0.4,0,0.7,0,1c0,0.5,0.2,0.9,0.7,1c0.5,0.2,1.1,0,1.4-0.4c0.1-0.1,0.1-0.4,0.1-0.5 c0-0.4,0-0.8,0-1.1H12h4.3c0,0.4,0,0.8,0,1.1c0,0.1,0.1,0.4,0.1,0.5c0.2,0.4,0.9,0.5,1.4,0.4c0.5-0.1,0.7-0.4,0.7-1 c0-0.3,0-0.7,0-1c0.1,0,0.1,0,0.2,0c0.2,0,0.4,0,0.6,0c0.4,0,0.6-0.3,0.7-0.8c0.1-0.6,0.1-1.1,0.1-1.7c0-1.6,0-3.3,0-4.9 C19.4,12.1,18.7,12.3,18,12.4L18,12.4z M7.6,17.6c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2s1.2,0.5,1.2,1.2 C8.8,17.1,8.2,17.6,7.6,17.6z M16.4,17.6c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2s1.2,0.5,1.2,1.2 C17.5,17.1,17,17.6,16.4,17.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.2,6.2V4.8c0-0.4-0.3-0.8-0.8-0.8s-0.8,0.3-0.8,0.8v1.7c0,0,0,0,0,0c0,0.1,0,0.2,0.1,0.3 C16.8,6.9,16.9,7,17,7l1.7,1.7C18.8,8.9,19,9,19.2,9s0.4-0.1,0.5-0.2C20,8.4,20,8,19.7,7.7L18.2,6.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.5,1.2c-2.9,0-5.3,2.4-5.3,5.3c0,2.9,2.4,5.3,5.3,5.3s5.3-2.4,5.3-5.3C22.8,3.6,20.4,1.2,17.5,1.2z  M17.5,10.3c-2.1,0-3.8-1.7-3.8-3.8c0-2.1,1.7-3.8,3.8-3.8c2.1,0,3.8,1.7,3.8,3.8C21.3,8.6,19.6,10.3,17.5,10.3z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusTimetable);
export default __webpack_public_path__ + "static/media/BusTimetable.e8c8c46a.svg";
export { ForwardRef as ReactComponent };